/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { AnyCluster, CCMService } from '@modules/ccm-lib/types'

import AutoOpsServiceItem from './AutoOpsServiceItem'
import EISServiceItem from './EISServiceItem'

type Props<T extends CCMService> = {
  service: T
  cluster: AnyCluster
}

function ServiceItemSelector<T extends CCMService>({ service, cluster }: Props<T>) {
  switch (service) {
    case 'auto_ops':
      return <AutoOpsServiceItem cluster={cluster} />
    case 'eis':
      return <EISServiceItem cluster={cluster} />
    default:
      return null
  }
}

export default ServiceItemSelector
